/*
 * cart-gel-guard.js — el gel automatico va AMARRADO al Protocolo Firmeza.
 *
 * Port de MX (2026-08-23, sesion 13). Motivo original alla (2026-07-27): un
 * usuario subio el stepper del carrito hasta 242 geles automaticos. El gel es
 * una suscripcion a 0 € hoy que luego cobra 29,99 € cada 90 dias POR UNIDAD,
 * asi que multiplicarlo es un problema real de cobro.
 *
 * Regla (Mau, 2026-08-22, heredada del canon MX): el gel automatico NO se
 * puede borrar solo. La unica forma de quitarlo es quitando el Protocolo: sin
 * Protocolo en el carrito, el gel se va solo (si se quedara, la clienta
 * pagaria un gel "gratis" sin protocolo).
 *
 * Que hace:
 *  1) Oculta el contador (+/-) Y la papelera SOLO en la linea del gel
 *     automatico del drawer de Rebuy.
 *  2) Respaldo en JS (cada vez que el carrito cambia):
 *     a) si la cantidad del gel queda > 1 (carritos viejos, API, UI stale), la
 *        regresa a 1;
 *     b) si NO hay ningun Protocolo en el carrito, quita TODAS las lineas del
 *        gel automatico.
 *
 * Nota: Rebuy renderiza su propia plantilla, pero al <li> le pone la clase
 * product-<handle>. Si el gel automatico pasa a un producto dummy (patron MX),
 * actualizar GEL_HANDLE y GEL_VARIANT aqui y los settings sub_variant_id /
 * sub_selling_plan_id del template.
 */
(function (global) {
  'use strict';

  /* Dos geles automaticos (v14b): el del Protocolo (auto, se envia hoy)
     y el del Starter (reposicion, SKU diferido: el 1er envio es al dia 30
     via Skio Journey). El guard trata a ambos igual. */
  var GEL_HANDLES = ['gel-conductor-hidratante-auto', 'gel-conductor-hidratante-reposicion'];
  var GEL_VARIANTS = [49514997154048, 49542155305216];
  var DEVICE_HANDLES = ['skindion-rosa', 'skindion-negro'];
  var DEVICE_VARIANTS = [46066738331904, 46066738364672];
  var MAX_QTY = 1;

  function isGel(it) {
    if (!it) return false;
    if (GEL_VARIANTS.indexOf(it.variant_id) !== -1) return true;
    return !!it.handle && GEL_HANDLES.indexOf(it.handle) !== -1;
  }

  function isDevice(it) {
    if (!it) return false;
    if (DEVICE_VARIANTS.indexOf(it.variant_id) !== -1) return true;
    return !!it.handle && DEVICE_HANDLES.indexOf(it.handle) !== -1;
  }

  /**
   * Logica pura (a): dadas las lineas del carrito, que cantidades hay que bajar a 1.
   * @param {Array<{variant_id:number, quantity:number, key:string, handle?:string}>} items
   * @returns {Array<{key:string, quantity:number}>}
   */
  function planClamp(items, maxQty) {
    maxQty = maxQty || MAX_QTY;
    var out = [];
    (items || []).forEach(function (it) {
      if (isGel(it) && it.quantity > maxQty) {
        out.push({ key: it.key, quantity: maxQty });
      }
    });
    return out;
  }

  /**
   * Logica pura (b): sin Protocolo en el carrito, el gel automatico sale (qty 0).
   * @returns {Array<{key:string, quantity:number}>}
   */
  function planOrphan(items) {
    var list = items || [];
    var hasDevice = list.some(isDevice);
    if (hasDevice) return [];
    var out = [];
    list.forEach(function (it) {
      if (isGel(it) && it.quantity > 0) out.push({ key: it.key, quantity: 0 });
    });
    return out;
  }

  /**
   * Logica pura (c) — exclusividad de ofertas (14f, bug cazado por Mau el
   * 2026-08-24): si hay MAS de una linea de gel (automatico Y reposicion a
   * la vez, herencia de un cambio de oferta a medias), se queda solo la MAS
   * RECIENTE (cart.js lista lo ultimo añadido primero) y el resto sale. El
   * ATC ya evita crear la mezcla; esto sana cestas que venian rotas.
   */
  function planExclusive(items) {
    var out = [];
    var seen = false;
    (items || []).forEach(function (it) {
      if (!isGel(it)) return;
      if (!seen) { seen = true; return; }
      if (it.quantity > 0) out.push({ key: it.key, quantity: 0 });
    });
    return out;
  }

  /** Plan completo: huerfanos (qty 0), luego exclusividad, luego clamp. */
  function planGuard(items, maxQty) {
    var orphan = planOrphan(items);
    if (orphan.length) return orphan;
    var exclusive = planExclusive(items);
    if (exclusive.length) return exclusive;
    return planClamp(items, maxQty);
  }

  /**
   * Logica pura (d) — autocurado del cupon (14n, tras el bug del upgrade
   * que dejaba "Skindion Starter" aplicado a una cesta del Protocolo).
   * El codigo aplicado AL CARRITO debe corresponder al gel presente:
   *   gel automatico  -> "Protocolo Firmeza"
   *   gel reposicion  -> "Skindion Starter"
   *   sin gel de oferta -> ninguno de los nuestros
   * Devuelve null si todo cuadra, o la lista de codigos que hay que
   * dejar aplicada (conservando los codes AJENOS, p. ej. de creadoras,
   * que desde la 14c pueden convivir con los nuestros).
   */
  var CODIGOS_OFERTA = { 49514997154048: 'Protocolo Firmeza', 49542155305216: 'Skindion Starter' };
  var CODIGOS_NUESTROS = ['Protocolo Firmeza', 'Skindion Starter'];

  function codigoEsperado(items) {
    for (var i = 0; i < (items || []).length; i++) {
      var code = CODIGOS_OFERTA[Number(items[i].variant_id)];
      if (code) return code;
    }
    return '';
  }

  function codigosAplicados(cart) {
    var out = [];
    function meter(app) {
      if (app && app.type === 'discount_code' && app.title && out.indexOf(app.title) === -1) out.push(app.title);
    }
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var allocs = items[i].line_level_discount_allocations || [];
      for (var a = 0; a < allocs.length; a++) meter(allocs[a].discount_application);
    }
    var nivel = (cart && cart.cart_level_discount_applications) || [];
    for (var c = 0; c < nivel.length; c++) meter(nivel[c]);
    return out;
  }

  function planDiscount(cart) {
    var esperado = codigoEsperado(cart && cart.items);
    var aplicados = codigosAplicados(cart);
    var nuestrosAplicados = aplicados.filter(function (t) { return CODIGOS_NUESTROS.indexOf(t) !== -1; });
    var coherente = esperado
      ? nuestrosAplicados.length === 1 && nuestrosAplicados[0] === esperado
      : nuestrosAplicados.length === 0;
    if (coherente) return null;
    var ajenos = aplicados.filter(function (t) { return CODIGOS_NUESTROS.indexOf(t) === -1; });
    if (esperado) ajenos.push(esperado);
    return ajenos.join(',');
  }

  // ---- Node (tests) ----
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      planClamp: planClamp,
      planOrphan: planOrphan,
      planExclusive: planExclusive,
      planGuard: planGuard,
      planDiscount: planDiscount,
      GEL_HANDLES: GEL_HANDLES,
      GEL_VARIANTS: GEL_VARIANTS,
      DEVICE_VARIANTS: DEVICE_VARIANTS,
      DEVICE_HANDLES: DEVICE_HANDLES,
      MAX_QTY: MAX_QTY
    };
    return;
  }

  // ---- Navegador ----
  var doc = global.document;
  if (!doc) return;

  // 1) Esconder el contador y la papelera en la linea del gel. Tambien el nombre
  //    y el separador de la propiedad de linea ("Gel automático :"), para que la
  //    linea del drawer EMPIECE con el valor ("Hoy 0 € · luego 29,99 €…").
  //    Markup de Rebuy verificado en MX: .rebuy-cart__flyout-item-property
  //    > -property-name + -property-separator + -property-value.
  //    14f (Mau, 2026-08-24): fuera tambien la linea del NOMBRE del selling
  //    plan (--delivery-frequency, "Reposición cada 90 días · 1er envío en
  //    30 días"): repetia lo que ya dice la nota y Mau quiere UNA sola linea
  //    limpia bajo el titulo del gel.
  function injectCss() {
    if (doc.getElementById('cart-gel-guard-css')) return;
    var css = '';
    GEL_HANDLES.forEach(function (h) {
      var sel = '.rebuy-cart__flyout-item.product-' + h;
      css +=
        sel + ' .rebuy-cart__flyout-item-quantity{display:none!important;}' +
        sel + ' .rebuy-cart__flyout-item-remove{display:none!important;}' +
        sel + ' .rebuy-cart__flyout-item-property--delivery-frequency{display:none!important;}' +
        sel + ' .rebuy-cart__flyout-item-property-name,' +
        sel + ' .rebuy-cart__flyout-item-property-separator{display:none!important;}';
    });
    var st = doc.createElement('style');
    st.id = 'cart-gel-guard-css';
    st.textContent = css;
    (doc.head || doc.documentElement).appendChild(st);
  }

  // 2) Respaldo: huerfanos fuera, cantidad a 1, y cupon coherente con el
  //    gel presente (autocurado 14n: /cart/update.js {discount} reemplaza
  //    de verdad un codigo amarrado; verificado en el live).
  var enVuelo = false;
  function guard() {
    if (enVuelo) return;
    enVuelo = true;
    global.fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cambios = planGuard(cart && cart.items);
        if (!cambios.length) {
          var codigos = planDiscount(cart);
          if (codigos === null) return null;
          return global.fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ discount: codigos })
          }).then(function () {
            try {
              if (global.Rebuy && global.Rebuy.SmartCart && global.Rebuy.SmartCart.refresh) global.Rebuy.SmartCart.refresh();
              else doc.dispatchEvent(new global.CustomEvent('rebuy:cart.refresh'));
            } catch (e) {}
          });
        }
        // Un cambio a la vez: /cart/change.js reescribe el carrito completo.
        return cambios.reduce(function (p, c) {
          return p.then(function () {
            return global.fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: c.key, quantity: c.quantity })
            });
          });
        }, global.Promise.resolve()).then(function () {
          // Refrescar el drawer para que muestre el carrito corregido.
          try {
            if (global.Rebuy && global.Rebuy.SmartCart && global.Rebuy.SmartCart.refresh) global.Rebuy.SmartCart.refresh();
            else doc.dispatchEvent(new global.CustomEvent('rebuy:cart.refresh'));
          } catch (e) {}
        });
      })
      .catch(function () { /* nunca romper el carrito por el respaldo */ })
      .then(function () { global.setTimeout(function () { enVuelo = false; }, 400); });
  }

  function start() {
    injectCss();
    guard();
    ['rebuy:cart.change', 'rebuy:cart.add', 'rebuy:cart.ready', 'cart:updated']
      .forEach(function (ev) { doc.addEventListener(ev, function () { global.setTimeout(guard, 250); }, false); });
    // El drawer se puede abrir desde cualquier pagina; re-inyectar si Rebuy
    // reescribe el <head> o si su CSS carga despues.
    global.setInterval(injectCss, 2000);
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start);
  else start();
})(typeof globalThis !== 'undefined' ? globalThis : this);
